import React from 'react';
import PropTypes from 'prop-types';
import { is } from 'ramda';

import exists from 'lib/exists';

const color = (clr, value) => (exists(clr) ? (is(Function, clr) ? clr(value) : clr) : null);

const Handle = (handleColor, showTooltip) => ({ value, offset, style }) => { // eslint-disable-line
    const handleInlineStyle = {
      ...style,
      left: offset + '%',
      backgroundColor: color(handleColor, value),
    };

    return (
      <div className="rc-slider-handle" style={handleInlineStyle}>
        {showTooltip && (
          <div className="rc-slider-tooltip" style={style}>
            <span>{value}</span>
          </div>
        )}
      </div>
    );
  };

Handle.propTypes = {
  value: PropTypes.number,
  offset: PropTypes.number,
  handleColor: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  style: PropTypes.object,
  showTooltip: PropTypes.bool,
};

export default Handle;
